import { useMemo } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import type {
  IAppointmentDataStatus,
  IAppointmentDataStatusProps,
} from "@components/molecules/appointmentStatus";
import { StatusChipBase } from "@components/atoms/statusChipBase";
import classes from "@components/molecules/appointmentStatus/styles.module.scss";
import { appointmentDataStatusData } from "@components/molecules/appointmentStatus/types";

export function AppointmentDataStatus(props: IAppointmentDataStatusProps) {
  const { status, isMsp, mspType } = props;

  const { t } = useTranslation("common");

  const statuses = appointmentDataStatusData(t, !!isMsp, mspType);

  // Use useMemo to memoize the rendered appointment status chips.
  const renderAppointmentStatus = useMemo(() => {
    return (
      <>
        {Object.keys(statuses)?.map((key) => {
          const statusData = statuses[key as IAppointmentDataStatus];

          return (
            <StatusChipBase
              key={key}
              label={statusData?.label}
              color={statusData?.color}
              disabled={status !== key}
            />
          );
        })}
      </>
    );
  }, [status, statuses]);

  return (
    // Render the appointment status chips in a row.
    <div className={clsx(classes.appointmentStatusRow)}>
      {renderAppointmentStatus}
    </div>
  );
}
